import ReactGA from 'react-ga4';

export default class GA4Helper {
  public static initialize = (trackingId: string) => {
    ReactGA.initialize(trackingId);
  };

  public static pageView = () => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  };

  public static event = (category: string, action: string, label = '') => {
    ReactGA.event({ category, action, label });
  };
}
